import { dbService } from './database';

export interface AppSettings {
  theme: 'dark' | 'light';
  soundEnabled: boolean;
  hapticsEnabled: boolean;
}

export class SettingsRepository {
  public async getSettings(): Promise<AppSettings> {
    const db = await dbService.getDb();

    if (!db) {
      const theme = (localStorage.getItem('setting_theme') as 'dark' | 'light') || 'dark';
      const soundEnabled = localStorage.getItem('setting_soundEnabled') !== 'false';
      const hapticsEnabled = localStorage.getItem('setting_hapticsEnabled') !== 'false';
      return { theme, soundEnabled, hapticsEnabled };
    }

    try {
      const res = await db.query('SELECT * FROM settings');
      const settingsMap = new Map<string, string>();

      if (res.values) {
        for (const row of res.values) {
          settingsMap.set(row.key, row.value);
        }
      }

      return {
        theme: (settingsMap.get('theme') as 'dark' | 'light') || 'dark',
        soundEnabled: settingsMap.get('soundEnabled') !== 'false',
        hapticsEnabled: settingsMap.get('hapticsEnabled') !== 'false',
      };
    } catch {
      const theme = (localStorage.getItem('setting_theme') as 'dark' | 'light') || 'dark';
      const soundEnabled = localStorage.getItem('setting_soundEnabled') !== 'false';
      const hapticsEnabled = localStorage.getItem('setting_hapticsEnabled') !== 'false';
      return { theme, soundEnabled, hapticsEnabled };
    }
  }

  public async setSetting(key: string, value: string): Promise<void> {
    localStorage.setItem(`setting_${key}`, value);

    const db = await dbService.getDb();
    if (!db) return;

    try {
      await db.run(
        `INSERT INTO settings (key, value) VALUES (?, ?)
         ON CONFLICT(key) DO UPDATE SET value = excluded.value`,
        [key, value]
      );
      await dbService.saveStore();
    } catch {
      // Ignore
    }
  }
}

export const settingsRepository = new SettingsRepository();
